import { render, staticRenderFns } from "./PriControlGroupPopulation.vue?vue&type=template&id=362cfdd9&scoped=true"
import script from "./PriControlGroupPopulation.vue?vue&type=script&lang=js"
export * from "./PriControlGroupPopulation.vue?vue&type=script&lang=js"
import style0 from "./PriControlGroupPopulation.vue?vue&type=style&index=0&id=362cfdd9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362cfdd9",
  null
  
)

export default component.exports